import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { CdnApiService } from '../../core/cdn';
import { CdnCardComponent } from './cdn-card.component';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    TranslateModule,
    FormsModule,
    MatIconModule,
    MatSlideToggleModule,
    MatFormFieldModule,
  ],
  declarations: [CdnCardComponent],
  exports: [CdnCardComponent],
  providers: [CdnApiService],
})
export class CdnModule {}
